<div id="{{ content?.slug }}">
  <div class="contentBlock" [innerHtml]="content?.content"></div>
</div>